var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containout"},[_c('Head',{attrs:{"child-message":_vm.childMessage}}),_c('div',{class:_vm.falv != true ? 'main' : 'flmain'},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }